<template>
  <v-container fluid dense>
    <v-card color="orange lighten-5">
      <v-card-title
        style="padding-top: 5px; padding-bottom:5px; text-overflow: ellipsis;"
        class="text-h6 d-flex justify-space-between"
        ><span>Buoni pasto</span
        ><span
          >Pezzi: {{ numeroPezzi }} Valore € {{ valoreSelezionato }}</span
        ></v-card-title
      >
      <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;"
        >Selezionare i tagli in base agli emettitori</v-card-subtitle
      >
      <v-tabs
        vertical
        v-model="modelTabs"
        height="83vh"
        background-color="grey lighten-5"
      >
        <v-tab
          v-for="(v, index) in emettitori"
          :key="index"
          class="categorie-left"
        >
          {{ v.descrizione }}
        </v-tab>
        <v-tabs-items v-model="modelTabs">
          <v-card class="d-flex justify-space-around flex-wrap" flat>
            <v-card
              v-for="(t, idx) in tagliEmettitore"
              :key="idx"
              class="pa-2 ma-3"
            >
              <v-card-title
                >Selezionati: {{ t.numeroSelezionati }}</v-card-title
              >
              <v-card-subtitle
                >Valore: € {{ t.numeroSelezionati * t.valore }}</v-card-subtitle
              >
              <v-card-title>Taglio: € {{ t.valore }}</v-card-title>
              <v-btn icon @click="decrementa(t)"
                ><v-icon large color="blue"
                  >mdi-minus-box-outline</v-icon
                ></v-btn
              >
              <v-btn class="ma-3 text-h5" @click="incrementa(t)"
                >€ {{ t.valore }}</v-btn
              >
              <v-btn icon @click="incrementa(t)"
                ><v-icon large color="green"
                  >mdi-plus-box-outline</v-icon
                ></v-btn
              >
            </v-card>
          </v-card>
        </v-tabs-items>
      </v-tabs>
      <!--         <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined text>ok</v-btn>            
        </v-card-actions>     -->
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import configurazioni from "@/services/configurazioniService.js";
import clienti from "@/services/clientiService.js";
import prodotti from "@/services/prodottiService.js";

export default {
  props: {
    chiave: { type: String, default: "not-set" },
  },
  mixins: [verificaLicenza],
  data: () => ({
    tipoColoreGruppo: "eccesso",
    menu: null,
    trigger: 1,
    modelTabs: null,
    emettitori: [],
    tagliDisponibili: [],
  }),
  async created() {
    const emettitori = await clienti.getEmettitori();
    this.emettitori = _.sortBy(
      emettitori.map((x) => {
        return { codice: x._id, descrizione: x.ragioneSociale };
      }),
      ["descrizione"]
    );

    // const buoniPasto = await prodotti.prodottiPerTipoBene('BUONOPASTO', false, 100, 'PRODOTTO', ['_id', 'descrizione', 'prezzo'])
    const buoniPasto = await prodotti.prodottiPerTipoBene(
      "BUONOPASTO",
      false,
      100,
      "PRODOTTO"
    );
    this.tagliDisponibili = buoniPasto.map((x) => {
      return {
        codice: x._id,
        descrizione: x.descrizione,
        emettitore: x.emettitore,
        valore: x.prezzo.L1.base,
        numeroSelezionati: 0, // passare già selezionati se riapertura
      };
    });
    const emettitoriCaricati = this.tagliDisponibili.map(
      (x) => x.emettitore.codice
    );
    this.emettitori = this.emettitori.filter((x) =>
      emettitoriCaricati.includes(x.codice)
    );
  },
  async mounted() {
    await this.gestioneToken();
    // const payload = await configurazioni.takeMemoriaCondivisa(this.chiave)
  },
  computed: {
    tagliEmettitore() {
      if (this.emettitori.length === 0 || this.modelTabs === null) return [];
      const codice = this.emettitori[this.modelTabs].codice;
      return _.sortBy(
        this.tagliDisponibili.filter((x) => x.emettitore.codice === codice),
        ["valore"]
      );
    },
    numeroPezzi() {
      return _.sumBy(this.tagliDisponibili, "numeroSelezionati");
    },
    valoreSelezionato() {
      return _.sumBy(this.tagliDisponibili, function(t) {
        return t.numeroSelezionati * t.valore;
      });
    },
  },
  methods: {
    async decrementa(item) {
      if (item.numeroSelezionati > 0) {
        item.numeroSelezionati--;
        await this.inviaAggiornamento();
      }
    },
    async incrementa(item) {
      item.numeroSelezionati++;
      await this.inviaAggiornamento();
    },
    async inviaAggiornamento() {
      // TODO: Se serve la descrizione dell'emettitore --> va aggiunto l'oggetto ai tagli disponibili invece di portarsi dietro due oggetti diversi
      const payload = {
        tagliSelezionati: this.tagliDisponibili.filter(
          (x) => x.numeroSelezionati > 0
        ),
      };
      await configurazioni.setMemoriaCondivisa(this.chiave, payload);
    },
  },
};
</script>
